import { render } from "./PlotOptionsEdit.vue?vue&type=template&id=28bf147a"
import script from "./PlotOptionsEdit.vue?vue&type=script&lang=js"
export * from "./PlotOptionsEdit.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__